import type { UserUuid } from "../../types/identity";

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;

export const isUserUuid = (value: unknown): value is UserUuid => typeof value === "string" && UUID.test(value);
